import * as React from 'react';
import * as _ from 'lodash';
import { useState, useEffect } from 'react';


type CountTransformTokensProps = {
    value: string
    debounceDelay?: number;
    maxTokensVisible?: number;
};

function getBackgroundColor(tokenCount) {
    const colorLimits = {
        512: 'rgba(255, 249, 0, 0.4)',
        1024: 'rgba(255, 219, 0, 0.4)',
        2048: 'rgba(255, 189, 0, 0.4)',
        3072: 'rgba(255, 139, 0, 0.4)',
        4000: 'rgba(255, 0, 0, 0.4)'
    };

    if (tokenCount < 512) return 'rgba(144, 238, 144, 0.4)';

    let bgColor;

    for (const limit in colorLimits) {
        if (tokenCount >= limit) {
            bgColor = colorLimits[limit];
        }
        if (tokenCount < limit) {
            break;
        }
    }

    return bgColor;
}


export function CountTransformTokens({ value, debounceDelay = 2000, maxTokensVisible = 512 }: CountTransformTokensProps) {
    const [count, setCount] = useState(null);

    useEffect(() => {
        const request = _.debounce((value, cb) => {
            window.tutorProject?.call('countTokens', {
                text: value
            }, function (e, res) {
                if (res && res.tokens !== undefined) {
                    cb(res.tokens);
                } else {
                    cb(null);
                    console.error(e);
                }
            });
        }, debounceDelay);

        request(value, (count) => {
            setCount(count);
        });
        return () => {
            request.cancel();
        };
    }, [value, debounceDelay]);

    if (count > maxTokensVisible) {
        return <div title="Run" className={`count-transform-tokens ${count !== null ? 'visible' : ''}`} >
            <div className="count-transform-tokens__bg" style={{ backgroundColor: getBackgroundColor(count) }}>
                Tokens: {count}
            </div>
        </div>;
    }

    return <></>;
}